
const slides = document.getElementById('slides');
const slider = slides.querySelector('#slider');
// const hero = slides.querySelector('#heroImg').firstChild;
const thumbs = slides.querySelectorAll('.aSlide');

let startX = 0;

for (let i = 0; i < thumbs.length; i++) {

    thumbs[i].addEventListener('click', function(e) {

      e.preventDefault();

      const heroes = slides.querySelectorAll('.aHero');

      let theOffset = heroes[i].offsetWidth * i;

      startX = theOffset;

      if (startX > 0) {
        startX = -Math.abs(startX);
      }

      slider.style.transform = `translateX(${startX}px)`;


      // const heroUrl = thumbs[i].getAttribute('href');
      // hero.src = heroUrl;
      // hero.srcset = heroUrl;
  
    });
    
}


// Left / Right swipes:
let touchstartX = 0
let touchendX = 0
    
function checkDirection(e) {

  const heroes = slides.querySelectorAll('.aHero');
  
  if (touchendX < touchstartX) {
    startX = startX - heroes[0].offsetWidth;
  }
  if (touchendX > touchstartX) {
    startX = startX + heroes[0].offsetWidth
  }

  if (startX > 0) {
    startX = -Math.abs(startX);
  }

  slider.style.transform = `translateX(${startX}px)`;
  
}

slider.addEventListener('touchstart', e => {
  touchstartX = e.changedTouches[0].screenX;
})

slider.addEventListener('touchend', e => {
  touchendX = e.changedTouches[0].screenX;
  checkDirection()
})


